import { onAPhone } from './rebook-message'
import { openOwnSend, reserveOwnSend, sendingSettings } from './email-send'
import { copyText, showCopyFailed } from './copied'
import { api } from './api'
import { acceptedVisitMessage } from './rebook-message'
import { BOOKING_OTHER_JOBS_NOTICE, type OfferFacts } from '../functions/lib/customer-offer-data'
import { sendControl } from './contact-ui'
import { linkFor, wayFor } from './contact'
import { el } from './ui'
import type { Customer, Clean } from './types'
// The existing confirmation message builder and phone send controls. Nothing sends automatically.
export function openBookingWelcome(customer:Customer,visit:Clean):void {
 if(!onAPhone())void sendingSettings().catch(()=>{})
 const dialog=el('dialog',{class:'booking-dialog customer-offer-sheet'}) as HTMLDialogElement
 const close=el('button',{type:'button',class:'sheet-x'},'Close');close.addEventListener('click',()=>dialog.close())
 const body=el('div',{class:'customer-offer-body'}),status=el('p',{'aria-live':'polite'})
 const words=el('textarea',{'aria-label':'Booking confirmation',rows:'8'}) as HTMLTextAreaElement
 const sends=el('div'),copy=el('button',{type:'button',class:'link-button'},'Copy')
 dialog.append(el('header',{class:'booking-head'},el('h2',{},'Their booking message'),close),body)
 body.append(el('label',{},'Message to send',words),sends,copy,status)
 dialog.addEventListener('close',()=>dialog.remove());document.body.append(dialog);dialog.showModal()
 let filled=false,visitKey:string|null=null
 const fresh=async()=>{
  const detail=await api<{customer:Customer;offer_facts?:OfferFacts;cleans:Clean[]}>(`/api/customers/${customer.id}`)
  const current=detail.cleans.find(v=>v.id===visit.id)
  if(!current||current.state!=='booked'||current.blocked_reason)throw new Error('This visit changed. Close and reopen its message.')
  const key=JSON.stringify([current.date,current.time_slot,current.confirmed,current.time_agreed_for])
  if(visitKey!==null&&visitKey!==key)throw new Error('This visit changed. Close and reopen its message.')
  visitKey=key
  const facts=detail.offer_facts,a=facts?.agreement
  const first=detail.cleans.filter(v=>v.job_id==null&&!v.rest_of).sort((x,y)=>x.date.localeCompare(y.date)||x.id-y.id)[0]
  const include=first?.id===visit.id&&a?.state==='agreed'&&a.source==='at_booking'&&JSON.parse(a.channels_json).includes(wayFor(detail.customer))&&!facts?.stopped&&!facts?.stop_suggestion
  if(!filled){words.value=acceptedVisitMessage(detail.customer.name,current,{firstBooking:true,otherJobsNotice:include?BOOKING_OTHER_JOBS_NOTICE:undefined});filled=true}
  else if(!include)words.value=words.value.replace(BOOKING_OTHER_JOBS_NOTICE,'').replace(/\n\n\n/g,'\n\n')
  return detail.customer
 }
 async function draw():Promise<void>{
  try{
   const c=await fresh();if(!dialog.open)return
   const control=sendControl(c,words.value,'Your first clean',{className:'btn-primary',changed:()=>void draw()})
   // A native open-in-new-tab must not bypass the latest agreement/visit check.
   if(control.link)control.link.href='#'
   const send=(e:Event)=>{
    const target=e.target as Element
    if(!target.closest('a'))return
    e.preventDefault();e.stopImmediatePropagation()
    const href=linkFor(wayFor(c),c,words.value,'Your first clean').href
    const reserved=onAPhone()||!href?null:reserveOwnSend(href)
    if(reserved)reserved.opener=null
    void fresh().then(current=>{if(!dialog.open){reserved?.close();return}const link=linkFor(wayFor(current),current,words.value,'Your first clean');if(link.href){if(onAPhone())window.open(link.href,'_self','noopener');else openOwnSend({href:link.href,tab:reserved,name:current.name,confirm:false,sent:()=>{status.textContent='Message sent'}})}else{reserved?.close();status.textContent=link.missing??'Check their contact details.'}}).catch(e=>{reserved?.close();status.textContent=(e as Error).message||'Check your signal before sending their message.'})
   }
   control.root.addEventListener('click',send,{capture:true})
   control.root.addEventListener('auxclick',send,{capture:true})
   sends.replaceChildren(control.root)
  }catch{status.textContent='Their message could not load. Try again with signal.'}
 }
 copy.addEventListener('click',()=>{void fresh().then(async()=>{if(await copyText(words.value,{button:copy,what:'message'}))status.textContent=''}).catch(e=>{status.textContent=(e as Error).message||'Their message could not load. Try again with signal.';showCopyFailed(copy,'message')})})
 void draw()
}
